import { render, staticRenderFns } from "./ClubPendingPayment.vue?vue&type=template&id=21acfa39&"
import script from "./ClubPendingPayment.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ClubPendingPayment.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21acfa39')) {
      api.createRecord('21acfa39', component.options)
    } else {
      api.reload('21acfa39', component.options)
    }
    module.hot.accept("./ClubPendingPayment.vue?vue&type=template&id=21acfa39&", function () {
      api.rerender('21acfa39', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/appointment/vrach/new/components/DoctorAppointmentForm/components/AppointmentScreens/components/ClubPendingPayment/ClubPendingPayment.vue"
export default component.exports